import {Component, OnInit, Input} from "@angular/core";
import {Constants} from "../../services/constants";
import {Params, ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-dynamic-page',
  templateUrl: './dynamic-page.component.html',
})
export class DynamicPageComponent implements OnInit {

  data: any;

  @Input()
  private fileName: string = "overview";
  private tenantBucket = Constants.TENANT_BUCKET();

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.fileName = params['id'] + ".html";
      this.loadDoc();
    });
  }

  loadDoc() {
    let self = this;
    let xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        self.data = xhttp.responseText;
      }
    };
    xhttp.open("GET", Constants.TENANT_BUCKET() + this.fileName + "?" + new Date().getDay().toString(), true);
    xhttp.setRequestHeader("Access-Control-Allow-Origin", "*");
    xhttp.send();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dynamic-page/dynamic-page.component.ts